import { B2bMembership, PartnerModel, PartnerNetworkModel, PartnerStoreModel } from '@app/core/models';

/**
 * Варианты для выпадающих списков «Партнер / Сеть / Магазин» ограниченного пользователя
 * (сотрудник, агент) — из привязки GET /b2b/me/context, без админских поисков (они ему недоступны).
 * Заполнены только поля, нужные для отображения и выбора.
 */
export function scopePartnerOptions(m: B2bMembership | null): PartnerModel[] {
  if (!m?.partnerId) return [];
  return [
    {
      id: m.partnerId,
      legalName: m.partnerName,
      tradeName: m.partnerName,
      partnerType: m.partnerType ?? 'TOO',
      cooperationMode: m.cooperationMode,
    } as PartnerModel,
  ];
}

export function scopeNetworkOptions(m: B2bMembership | null): PartnerNetworkModel[] {
  if (!m?.partnerNetworkId) return [];
  return [
    {
      id: m.partnerNetworkId,
      partnerId: m.partnerId ?? '',
      partnerTradeName: m.partnerName ?? '',
      name: m.partnerNetworkName ?? m.partnerNetworkId,
    } as PartnerNetworkModel,
  ];
}

export function scopeStoreOptions(m: B2bMembership | null): PartnerStoreModel[] {
  if (!m?.partnerStoreId) return [];
  return [
    {
      id: m.partnerStoreId,
      networkId: m.partnerNetworkId ?? '',
      networkName: m.partnerNetworkName ?? '',
      partnerId: m.partnerId ?? '',
      partnerTradeName: m.partnerName ?? '',
      name: m.partnerStoreName ?? m.partnerStoreId,
      city: m.partnerStoreCity ?? '',
      address: m.partnerStoreAddress ?? '',
    } as PartnerStoreModel,
  ];
}
